<template>
    <v-row justify="center">
        <v-dialog v-model="delete_quote_dialog" max-width="35%" persistent>
            <v-card>
                <v-card-title>Confirm Deletion of Quote</v-card-title>
                <v-card-text>
                    <p>Are you sure you want to delete this quote? Any data attached to this quote will be deleted.</p>
                    <QuoteDeleteImpact :quote_id="quote_id" :active="delete_quote_dialog" @blocked="setBlocked" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="0" dense @click="closeDeleteQuoteDialog()" class="btn-font-format"
                        style="width: 120px;font-weight: bold;">
                        <label class="text-proper-case">No</label>
                    </v-btn>
                    <v-btn elevation="0" dense class="btn-font-format" style="width: 120px;font-weight: bold;"
                        color="primary" :disabled="blocked" @click="deleteQuote()">
                        <label class="text-proper-case">Yes</label>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import QuoteDeleteImpact from './QuoteDeleteImpact.vue'

export default {
    components: { QuoteDeleteImpact },
    data: () => ({
        blocked: false,
    }),
    props: [
        'delete_quote_dialog', 'quote_id'
    ],
    methods: {
        setBlocked(value) {
            this.blocked = value
        },
        closeDeleteQuoteDialog() {
            this.$emit('closeDeleteQuoteDialog')
        },
        deleteQuote() {
            this.$emit('deleteQuote')
        }
    },
}

</script>

<style lang="scss" scoped>
.btn-font-format {
    font-family: 'Manrope';
    text-transform: capitalize;
    font-size: 14px;
    font-weight: 400;
}

.form-label {
    font-family: 'Manrope';
    font-size: 12px;
    font-weight: 600;
    color: #7C7C7C;
}

.v-card__title {
    font-family: 'Manrope';
    font-weight: 600 !important;
    line-height: 43.71px;
}

.v-card__text {
    font-family: 'Manrope';
}
</style>